import CN from './zh';
import EN from './en';
import JA from './jp';
export default {
  CN,
  EN,
  JA,
};
